import { render } from "./AppMobileNotFooter.vue?vue&type=template&id=fcbcfd5a&scoped=true"
import script from "./AppMobileNotFooter.vue?vue&type=script&lang=js"
export * from "./AppMobileNotFooter.vue?vue&type=script&lang=js"

import "./AppMobileNotFooter.vue?vue&type=style&index=0&id=fcbcfd5a&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcbcfd5a"]])

export default __exports__